import { SET_JSD_WIDGET_READY } from "./actionTypes";

const INIT_STATE = {
  isReady: false,
};

const jsdWidget = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_JSD_WIDGET_READY:
      return { ...state, isReady: true };
    default:
      return state;
  }
};

export default jsdWidget;
